import { render } from "./Config.vue?vue&type=template&id=90099636&scoped=true"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"

import "./Config.vue?vue&type=style&index=0&id=90099636&lang=scss&scoped=true"
import "./Config.vue?vue&type=style&index=1&id=90099636&lang=scss"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90099636"]])

export default __exports__